let telReg = /^[1][2,3,4,5,7,8,9][0-9]{9}$/;//手机号
let wxReg = /^[a-zA-Z]{1}[-_a-zA-Z0-9]{5,19}$/;//微信号
let qqReg = /^[1-9]\d{4,9}$/;//qq
let phoneReg = /^[0]{1}[0-9]{2,3}-[0-9]{7,8}$/;//固定电话
let phoneOrTelReg = /(^[1][2,3,4,5,7,8][0-9]{9}$)|(^[0]{1}[0-9]{2,3}-[0-9]{7,8}$)/;//固定电话或者手机号
let integerReg = /^[1-9][0-9]*$|^0$/;//正整数
let floatReg = /^\d+(\.\d{1,2})?$/;//非负浮点数，两位小数
let userNameReg = /^[a-zA-Z0-9_-]{4,16}$/;//用户名字母数字下划线减号
let shenFenReg =/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;//身份证
let validateTel = (rule, value, callback) => {
  if (!value) {
    callback();
    return;
  }
  setTimeout(() => {
    if (!telReg.test(value)) {
      callback(new Error('手机号码有误'))
    } else {
      callback()
    }
  }, 200)
};
let validateWx = (rule, value, callback) => {
  if (!value) {
    callback();
    return;
  }
  setTimeout(() => {
    if (!wxReg.test(value)) {
      callback(new Error('微信号码有误'))
    } else {
      callback()
    }
  }, 200)
};
let validateQQ = (rule, value, callback) => {
  if (!value) {
    callback();
    return;
  }
  setTimeout(() => {
    if (!qqReg.test(value)) {
      callback(new Error('qq号码有误'))
    } else {
      callback()
    }
  }, 200)
};
let validatePhone = (rule, value, callback) => {
  if (!value) {
    callback();
    return;
  }
  setTimeout(() => {
    if (!phoneReg.test(value)) {
      callback(new Error('电话号码有误'))
    } else {
      callback()
    }
  }, 200)
};
let validatePhoneOrTel = (rule, value, callback) => {
  if (!value) {
    callback();
    return;
  }
  setTimeout(() => {
    if (!phoneOrTelReg.test(value)) {
      callback(new Error('电话号码有误'))
    } else {
      callback()
    }
  }, 200)
};
let validateInteger = (rule, value, callback) => {
  if (!value) {
    callback();
    return;
  }
  setTimeout(() => {
    let val = value.trim();
    if (!integerReg.test(val)) {
      callback(new Error('请输入非负整数'))
    } else {
      callback()
    }
  }, 200)
};
let validateFloat = (rule, value, callback) => {
  if (!value) {
    callback();
    return;
  }
  setTimeout(() => {
    if (!floatReg.test(value)) {
      callback(new Error('请输入非负数，至多保留两位小数!'))
    } else {
      callback()
    }
  }, 200)
};
let validateUserName = (rule, value, callback) => {
  if (!value) {
    callback();
    return;
  }
  setTimeout(() => {
    if (!userNameReg.test(value)) {
      callback(new Error('用户名必须是字母、数字、下划线、减号组成的4-16位字符'))
    } else {
      callback()
    }
  }, 200)
};
let validateshenFenNo = (rule, value, callback) => {
  if (!value) {
    callback();
    return;
  }
  setTimeout(() => {
    if (!shenFenReg.test(value)) {
      callback(new Error('证件号码有误'))
    } else {
      callback()
    }
  }, 200)
}
function checkPass(pass) {
  if (pass.length < 8 || pass.length>32) {
    return 0;
  }
  let ls = 0;
  if (pass.match(/([a-z])+/)) {
    ls++;
  }
  if (pass.match(/([0-9])+/)) {
    ls++;
  }
  if (pass.match(/([A-Z])+/)) {
    ls++;
  }
  if (pass.match(/[^a-zA-Z0-9]+/)) {
    ls++;
  }
  return ls
}

let validatePwd = (rule, value, callback) => {
  if (!value) {
    callback();
    return;
  }
  setTimeout(() => {
    if (checkPass(value)<3) {
      callback(new Error('密码必须是大写字母、小写字母、数字、特殊字符中任意三个组合的8-32位字符!'))
    } else {
      callback()
    }
  }, 200)
};

export default {
  // 手机号
  tel: {
    validator: validateTel, trigger: 'blur', transform(value) {
      return value ? value : null;
    }
  },
  // 固定电话
  phone: {
    validator: validatePhone, trigger: 'blur', transform(value) {
      return value ? value : null;
    }
  },
  //手机号和固定电话
  phoneOrTel: {
    validator: validatePhoneOrTel, trigger: 'blur', transform(value) {
      return value ? value : null;
    }
  },
  //qq
  qq: {
    validator: validateQQ, trigger: 'blur', transform(value) {
      return value ? value : null;
    }
  },
  //正整数
  intege: {
    validator: validateInteger, trigger: 'blur', transform(value) {
      return value ? value : null;
    }
  },
  //非负正浮点数
  positiveFloat: {
    validator: validateFloat, trigger: 'blur', transform(value) {
      return value ? value : null;
    }
  },
  //微信
  wx: {
    validator: validateWx, trigger: 'blur', transform(value) {
      return value ? value : null;
    }
  },
  //email
  email: {
    type: 'email', message: '请输入正确的email地址', trigger: 'blur', transform(value) {
      return value ? value.toString().trim() : value;
    }
  },
  //userName
  userName: {
    validator: validateUserName, trigger: 'blur', transform(value) {
      return value ? value : null;
    }
  },
  //pwd 密码复杂度验证
  pwd: {
    validator: validatePwd, trigger: 'blur', transform(value) {
      return value ? value : null;
    }
  },
  //pwd 密码复杂度验证
  shenfen: {
    validator: validateshenFenNo, trigger: 'blur', transform(value) {
      return value ? value : null;
    }
  },
  //输入不为空
  requiredInput: {
    required: true, trigger: 'blur', transform(value) {
      return value ? value.toString().trim() : value;
    }
  },
  //输入不为空
  requiredInputNumber: {
    required: true, trigger: 'blur'
  }
}



// WEBPACK FOOTER //
// ./src/service/formRules.js